import { Div } from '@fastnorth/kraken/components/layout';
import LeaderboardSkeleton from '../leaderboard/Leaderboard.skeleton.tsx';

const AwardsSkeleton = (): React.JSX.Element => (
  <Div data-testid="awards-skeleton">
    <LeaderboardSkeleton showTableControls={false} bypassDisplayMessages={true} />
  </Div>
);

export default AwardsSkeleton;
